"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFavoriteContainer = exports.ProductFavorite = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var axios_1 = __importDefault(require("axios"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../StoreApp/selectors");
var ProductFavorite = function (_a) {
    var product = _a.product, alwaysVisible = _a.alwaysVisible, big = _a.big;
    var _b = (0, react_1.useState)(product.isFavorite), isFavorite = _b[0], setIsFavorite = _b[1];
    var authenticityToken = (0, react_redux_1.useSelector)(selectors_1.authenticityTokenSelector);
    (0, react_1.useEffect)(function () {
        setIsFavorite(product.isFavorite);
    }, [product.isFavorite]);
    var toggleFavorite = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, e_1, res, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsFavorite(!isFavorite);
                    if (!!isFavorite) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.patch("/profile/favorites/".concat(product.id), {
                            authenticity_token: authenticityToken,
                        })];
                case 2:
                    res = _a.sent();
                    console.log(res);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    //
                    console.log('error2');
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 8];
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, (0, axios_1.default)({
                            url: "/profile/favorites/".concat(product.id),
                            method: 'DELETE',
                            data: {
                                authenticity_token: authenticityToken,
                            },
                        })];
                case 6:
                    res = _a.sent();
                    console.log(res);
                    return [3 /*break*/, 8];
                case 7:
                    e_2 = _a.sent();
                    console.log('error');
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(exports.ProductFavoriteContainer, { onClick: toggleFavorite, alwaysVisible: alwaysVisible, big: big }, isFavorite ? (react_1.default.createElement("i", { className: "fas fa-heart" })) : (react_1.default.createElement("i", { className: "far fa-heart" }))));
};
exports.ProductFavorite = ProductFavorite;
exports.ProductFavoriteContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  width: 32px;\n  height: 32px;\n  opacity: ", ";\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  color: red;\n  box-sizing: border-box;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  width: 32px;\n  height: 32px;\n  opacity: ", ";\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  color: red;\n  box-sizing: border-box;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n\n  ", "\n"])), function (p) { return (p.alwaysVisible ? 1 : 0); }, function (p) {
    return p.big &&
        "\n    font-size: 24px;\n    width: 48px;\n    height: 48px;\n  ";
});
var templateObject_1;
